var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-header-wrapper padding-rb" },
      [_c("PageHeader", { attrs: { title: "Batch Operation tool" } })],
      1
    ),
    _c(
      "div",
      { staticClass: "table-wrapper" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            attrs: {
              data: _vm.tableData,
              "element-loading-text": "Loading...",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "No.", width: "80", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ $index }) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            (_vm.currentPage - 1) * _vm.pageSize + $index + 1
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "fileName",
                label: "File Name",
                "min-width": "250",
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      row.downloadUrl
                        ? _c(
                            "a",
                            {
                              staticClass: "file-download-link",
                              attrs: {
                                href: row.downloadUrl,
                                title: row.fileName,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.downloadSourceFile(row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(row.fileName))]
                          )
                        : _c("span", [_vm._v(_vm._s(row.fileName))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "functionName",
                label: "Function",
                "min-width": "170",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "status", label: "Status", width: "130" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "uploadUser",
                label: "Upload User",
                "min-width": "140",
                "show-overflow-tooltip": "",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "uploadTime", label: "Upload Time", width: "180" },
            }),
            _c("el-table-column", {
              attrs: { label: "Progress", "min-width": "250" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("el-progress", {
                        attrs: {
                          percentage: _vm.overallProgressPercent(row),
                          status: _vm.progressBarStatus(row),
                          "stroke-width": 14,
                          "show-text": true,
                        },
                      }),
                      _c("div", { staticClass: "progress-detail" }, [
                        _c("span", { staticClass: "progress-step" }, [
                          _vm._v(_vm._s(_vm.stepProgressText(row))),
                        ]),
                        row.progressLabel && !_vm.isFailedProgressLabel(row)
                          ? _c("span", { staticClass: "progress-label" }, [
                              _vm._v(_vm._s(row.progressLabel)),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "progress-detail" }, [
                        _vm._v(
                          " Success " +
                            _vm._s(_vm.displayCount(row.successCount)) +
                            " · Fail " +
                            _vm._s(_vm.displayCount(row.failCount)) +
                            " · Total " +
                            _vm._s(_vm.displayCount(row.uploadCount)) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "uploadCount",
                label: "Upload Count",
                width: "120",
                align: "right",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "successCount",
                label: "Success Count",
                width: "130",
                align: "right",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "failCount",
                label: "Fail Count",
                width: "100",
                align: "right",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "Result", width: "120", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            disabled: !_vm.canExportErrors(row),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.downloadErrorFile(row)
                            },
                          },
                        },
                        [_vm._v(" Export ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrap" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 25, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }